export default "__VITE_ASSET__DNqET1Ui__"